<template>
  <div class="orderManege_page">
    <div class="title_box flex_center">
      <img src="./image/order_icon.png" class="order_icon" />
      <div class="flex_column">
        <div class="order_title">订单交易管理</div>
        <div class="order_subtitle">你可以在这里进行订单查询，修改</div>
      </div>
    </div>
    <div class="filter_content">
      <el-date-picker
        v-model="filterData.timeDate"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        class="mr12 mb12"
        size="small"
      >
      </el-date-picker>
      <el-input
        v-model="filterData.keywords"
        placeholder="订单编号，产品名称，文件名"
        class="mr12 mb12 width200"
        size="small"
      ></el-input>
      <el-select
        v-model="filterData.orderTimeType"
        placeholder="请选择"
        class="mr12 mb12 width150"
        size="small"
        @change="getInfo(1)"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button
        style="background-color: #00a0e9; color: #ffffff; border-color: #00a0e9"
        size="small"
        class="mb12"
        @click="getInfo(1)"
      >
        查询</el-button
      >
      <el-button
        style="background-color: #00a0e9; color: #ffffff; border-color: #00a0e9"
        size="small"
        class="mb12"
        @click="toExport"
        >导出</el-button
      >
    </div>
    <div class="content_box">
      <el-tabs
        v-model="filterData.orderType"
        type="card"
        @tab-click="getInfo(1)"
      >
        <el-tab-pane label="所有订单" name="ALL"></el-tab-pane>
        <el-tab-pane label="有效订单" name="valid"></el-tab-pane>
        <el-tab-pane label="待审核" name="verifying"></el-tab-pane>
        <el-tab-pane label="已审核" name="verifyed"></el-tab-pane>
        <el-tab-pane label="待付款" name="unpay"></el-tab-pane>
        <el-tab-pane label="已取消" name="cancel"></el-tab-pane>
        <el-tab-pane label="停发订单" name="stopSending"></el-tab-pane>
        <el-tab-pane label="异常订单" name="abnormal"></el-tab-pane>
        <el-tab-pane label="退件订单" name="refund"></el-tab-pane>
      </el-tabs>
      <div class="table_content">
        <el-table :data="tableData" style="width: 100%" v-loading="loading">
          <el-table-column prop="orderNo" label="单号/时间">
            <template slot-scope="scope">
              {{ scope.row.orderNo }}
              <br />
              {{ scope.row.createTime }}
            </template>
          </el-table-column>
          <el-table-column prop="fileName" label="文件名"> </el-table-column>
          <el-table-column
            prop="productName"
            label="产品名称"
          ></el-table-column>
          <el-table-column prop="orderPrice" label="总价">
            <template slot-scope="scope">
              <span class="price">￥{{ scope.row.orderPrice }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="freightPrice" label="配送信息">
            <template slot-scope="scope">
              <div>运费：￥{{ scope.row.freightPrice }}</div>
              <div>预估重量:{{ scope.row.weight }}KG</div>
              <div>到货省份:{{ scope.row.province }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="payType" label="支付方式">
            <template slot-scope="scope">
              <div>
                支付方式：{{
                  $enums.payTypeEnum.getLabelByValue(scope.row.payType)
                }}
              </div>
              <div>
                审核状态：{{
                  $enums.verifyStatusEnum.getLabelByValue(
                    scope.row.verifyStatus
                  )
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="address4" label="状态" width="100">
            <template slot-scope="scope">
              <div>
                {{
                  $enums.orderStatusEnum.getLabelByValue(scope.row.orderStatus)
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="address5" label="操作" width="150">
            <template slot-scope="scope">
              <div class="flex_center">
                <el-button
                  type="text"
                  class="mr12 price"
                  @click="toDetail(scope.row)"
                  >查看详情</el-button
                >
                <el-dropdown
                  @command="handleCommand($event, scope.row)"
                  v-if="
                    scope.row.orderStatus === 'UNPAY' ||
                    scope.row.orderStatus !== 'CANCEL' ||
                    (!['UNPAY', 'CANCEL', 'VERIFY_FAIL', 'VERIFYING'].includes(
                      scope.row.orderStatus
                    ) &&
                      scope.row.refundStatus === null)
                  "
                >
                  <span class="price pointer">
                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      command="A"
                      v-if="scope.row.orderStatus === 'UNPAY'"
                      >扫码支付</el-dropdown-item
                    >
                    <!-- <el-dropdown-item
                      command="B"
                      v-if="scope.row.orderStatus === 'VERIFYING'"
                      >修改地址</el-dropdown-item
                    > -->
                    <el-dropdown-item
                      command="C"
                      v-if="scope.row.orderStatus !== 'CANCEL' && (scope.row.orderStatus === 'UNPAY' || scope.row.verifyStatus === 'VERIFYING' || scope.row.orderStatus === 'VERIFY_FAIL')"
                      >取消订单</el-dropdown-item
                    >
                    <el-dropdown-item
                      command="D"
                      v-if="scope.row.orderStatus === 'UNPAY'"
                      >补传证书</el-dropdown-item
                    >
                    <el-dropdown-item
                      command="E"
                      v-if="
                        ![
                          'UNPAY',
                          'CANCEL',
                          'VERIFY_FAIL',
                          'VERIFYING',
                        ].includes(scope.row.orderStatus) &&
                        scope.row.refundStatus === null
                      "
                      >申请售后</el-dropdown-item
                    >
                    <el-dropdown-item
                      command="G"
                      v-if="scope.row.payType === 'WECHAT_PAY' && scope.row.orderStatus != 'CANCEL'"
                      >微信退款</el-dropdown-item
                    >

                    <!-- <el-dropdown-item command="F">合单信息</el-dropdown-item> -->
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="flex_end statics">
          本页统计：订单数量： {{ pageInfo.total }} 本页订单金额： 成交价：{{
            orderPirce
          }}元 共 {{ totalPrice }}元
        </div>
        <div class="flex_end statics" v-if="pageInfo.total > 10">
          <el-pagination
            :current-page.sync="pageInfo.pageNo"
            :page-size="pageInfo.pageSize"
            layout="total, prev, pager, next"
            :total="pageInfo.total"
            @current-change="changePage"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="合单信息" :visible.sync="tipsModel.flag" width="30%">
      <span>{{ tipsModel.content }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tipsModel.flag = false">取 消</el-button>
        <el-button
          type="primary"
          class="btn_style"
          @click="tipsModel.flag = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="订单支付" :visible.sync="payModel.flag" width="30%">
      <img :src="payModel.payUrl" alt="" class="payImg" />
      <span slot="footer" class="dialog-footer">
        <el-button class="btn_style" @click="payModel.flag = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="取消订单" :visible.sync="cancelModel.flag" width="30%">
      <span>确定要取消订单吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelModel.flag = false">取 消</el-button>
        <el-button class="btn_style" type="primary" @click="sureCancel"
          >确 认</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="补传证书"
      :visible.sync="certificateModel.flag"
      width="400"
    >
      <div>
        <el-card class="mb12">
          选择已有品牌授权书或商标注册证书(可选)
          <div class="flex mt12">
            <el-select
              v-model="certificateModel.authenticationId1"
              placeholder="选择已有品牌授权书或商标注册证书"
              style="flex: 1"
              class="mr12"
            >
              <el-option
                v-for="item in authenticationId1List"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-button
              type="primary"
              style="width: 80px"
              class="btn_style"
              @click="toSearch()"
              >刷新</el-button
            >
            <el-button
              type="primary"
              style="width: 80px"
              class="btn_style"
              @click="toUpload()"
              >上传</el-button
            >
          </div>
        </el-card>
        <el-card>
          选择委印许可证明(可选)
          <div class="flex mt12">
            <el-select
              v-model="certificateModel.authenticationId2"
              placeholder="选择已有委印许可证明"
              style="flex: 1"
              class="mr12"
            >
              <el-option
                v-for="item in authenticationId2List"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-button
              type="primary"
              style="width: 80px"
              class="btn_style"
              @click="toSearch()"
              >刷新</el-button
            >
            <el-button
              type="primary"
              style="width: 80px"
              class="btn_style"
              @click="toUpload()"
              >上传</el-button
            >
          </div>
        </el-card>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="certificateModel.flag = false">取 消</el-button>
        <el-button type="primary" class="btn_style" @click="sureCertificate"
          >确 认</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="修改地址" :visible.sync="addressModel.flag" width="30%">
      <div>
        <el-form :model="addressModel" label-width="100px">
          <el-form-item label="路线">
            <el-select
              v-model="addressModel.routeTitle"
              placeholder="请选择路线"
            >
              <el-option
                v-for="item in routeTitleList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="快递公司">
            <el-input
              v-model="addressModel.expressName"
              placeholder="请输入快递公司"
            ></el-input>
          </el-form-item>
          <el-form-item label="省市区">
            <el-cascader
              v-model="addressModel.addressArray"
              :options="addressOptions"
              :props="{ expandTrigger: 'hover' }"
              style="width: 100%"
              @change="changeAddressArray"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="详细地址">
            <el-input
              v-model="addressModel.address"
              placeholder="请输入详细地址"
              type="textarea"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input
              v-model="addressModel.phone"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系人">
            <el-input
              v-model="addressModel.contactName"
              placeholder="请输入联系人"
            ></el-input>
          </el-form-item>
          <el-form-item label="预计运费">
            <span>￥{{ addressModel.freightPrice }}</span>
            <el-button @click="toGetPrice">估 价</el-button>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addressModel.flag = false">取 消</el-button>
        <el-button class="btn_style" type="primary" @click="sureChangeAddress"
          >确 认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import china from "../../assets/json/pcas-code.json";
import {
  orderManegeApi,
  orderListImportApi,
  orderPayApi,
  orderPayCheckApi,
  cancelOrderApi,
  authenticationApi,
  changeAddressApi,
  changeAddressPostageApi,
  authenticationListApi,
  routeListApi,
  wechatRefundApi,
} from "../../api/index";
export default {
  name: "orderManege",
  data() {
    return {
      filterData: {
        timeDate: [],
        keywords: "",
        orderTimeType: "today",
        orderType: "ALL",
      },
      options: [
        {
          value: "today",
          label: "今日订单",
        },
        {
          value: "yesterday",
          label: "昨日订单",
        },
        {
          value: "week",
          label: "本周订单",
        },
        {
          value: "laseWeek",
          label: "上周订单",
        },
        {
          value: "month",
          label: "本月订单",
        },
        {
          value: "lastMonth",
          label: "上月订单",
        },
        {
          value: "year",
          label: "本年订单",
        },
      ],
      tableData: [],
      pageInfo: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      orderPirce: 0,
      totalPrice: 0,
      loading: false,
      tipsModel: {
        flag: false,
        content: "",
      },
      payModel: {
        flag: false,
        payUrl: "", //支付二维码
        orderId: "", //订单号
        payStatus: false,
      },
      cancelModel: {
        flag: false,
        orderId: "",
      },
      certificateModel: {
        flag: false,
        authenticationId1: "",
        authenticationId2: "",
      },
      authenticationId1List: [],
      authenticationId2List: [],
      addressModel: {
        flag: false,
        orderId: 0,
        freightPrice: 0,
        routeTitle: "路线",
        expressName: "",
        addressArray: [],
        province: "",
        city: "",
        area: "",
        street: "",
        address: "",
        phone: "",
        contactName: "",
      },
      addressOptions: [],
      routeTitleList: [],
    };
  },
  created() {
    const address = china.map((province) => {
      const citys = province.children.map((f) => {
        const district = f.children.map((item) => {
          const street = item.children.map((s) => {
            return {
              name: s.name,
              code: s.code,
              value: s.name,
              label: s.name,
            };
          });
          return {
            name: item.name,
            code: item.code,
            value: item.name,
            label: item.name,
            children: street,
          };
        });
        return {
          name: f.name,
          code: f.code,
          children: district,
          value: f.name,
          label: f.name,
        };
      });
      return {
        name: province.name,
        code: province.code,
        value: province.name,
        label: province.name,
        children: citys,
      };
    });
    this.addressOptions = address;
  },
  activated() {
    this.getInfo(1);
  },
  mounted() {
    this.getRouteTitleList();
    this.getauthenList();
  },
  methods: {
    changePage(page) {
      this.pageInfo.pageNo = page;
      this.getInfo(this.pageInfo.pageNo);
    },
    getInfo(page = 1) {
      this.pageInfo.pageNo = page;
      if (this.loading) {
        return;
      }
      this.loading = true;
      orderManegeApi({
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        startDate:
          this.filterData.timeDate.length === 2
            ? this.$moment(this.filterData.timeDate[0]).format(
                "YYYY-MM-DD 00:00:00"
              )
            : null,
        endDate:
          this.filterData.timeDate.length === 2
            ? this.$moment(this.filterData.timeDate[1]).format(
                "YYYY-MM-DD 23:59:59"
              )
            : null,
        keywords: this.filterData.keywords,
        orderTimeType: this.filterData.orderTimeType,
        orderType:
          this.filterData.orderType === "ALL"
            ? null
            : this.filterData.orderType,
      })
        .then((res) => {
          if (res.resultStatus) {
            this.tableData = res.resultData.orderList || [];
            this.pageInfo.total = res.resultData.totalNum || 0;
            this.orderPirce = res.resultData.orderPirce || 0;
            this.totalPrice = res.resultData.totalPrice || 0;
          } else {
            this.tableData = [];
            this.pageInfo.total = 0;
            this.orderPirce = 0;
            this.totalPrice = 0;
            this.$message.warning(res.errorMessage);
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toExport() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      orderListImportApi({
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        startDate:
          this.filterData.timeDate.length === 2
            ? this.$moment(this.filterData.timeDate[0]).format(
                "YYYY-MM-DD 00:00:00"
              )
            : null,
        endDate:
          this.filterData.timeDate.length === 2
            ? this.$moment(this.filterData.timeDate[1]).format(
                "YYYY-MM-DD 23:59:59"
              )
            : null,
        keywords: this.filterData.keywords,
        orderTimeType: this.filterData.orderTimeType,
        orderType:
          this.filterData.orderType === "ALL"
            ? null
            : this.filterData.orderType,
      })
        .then((res) => {
          this.$convertRes2Blob(res, "订单列表导出数据");
          this.$message.success("导出成功");
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toDetail(data) {
      this.$router.push({
        name: "orderDetail",
        query: {
          orderId: data.orderId,
        },
      });
    },
    handleCommand(command, data) {
      switch (command) {
        case "A":
          orderPayApi({
            orderId: data.orderId,
          }).then((res) => {
            if (res.resultStatus) {
              if (res.resultData.payUrl) {
                this.payModel = {
                  flag: true,
                  payUrl: res.resultData.payUrl, //支付二维码
                  orderId: res.resultData.orderId, //订单号
                  payStatus: false,
                };
                this.checkPay();
              }
            } else {
              this.$message.warning(res.errorMessage);
            }
          });
          break;
        case "B":
          this.addressModel = {
            flag: true,
            orderId: data.orderId,
            freightPrice: null,
            routeTitle: "路线",
            expressName: "",
            addressArray: [],
            province: "",
            city: "",
            area: "",
            street: "",
            address: "",
            phone: "",
            contactName: "",
          };
          break;
        case "C":
          this.cancelModel = {
            flag: true,
            orderId: data.orderId,
          };
          break;
        case "D":
          this.certificateModel = {
            flag: true,
            authenticationId1: "",
            authenticationId2: "",
          };
          break;
        case "E":
          this.$router.push({
            name: "application_after",
            query: {
              orderId: data.orderId,
            },
          });
          break;
        case "F":
          this.tipsModel = {
            flag: true,
            content: data.orderNo,
          };
          break;
        case "G":
          // 微信退款
          this.$confirm('确定要申请微信退款吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // 调用微信退款接口
            wechatRefundApi(data.orderId).then((res) => {
              if (res.resultStatus) {
                this.$message.success('微信退款申请成功');
              } else {
                this.$message.warning(res.errorMessage);
              }
            }).catch((error) => {
              this.$message.error('微信退款申请失败');
              console.error('微信退款接口调用失败:', error);
            }).finally(()=>{
              this.getInfo(1)
            });
          });
          break;
        default:
          break;
      }
    },
    checkPay() {
      orderPayCheckApi({
        orderId: this.payModel.orderId,
      })
        .then((res) => {
          if (res.resultStatus && res.resultData.payStatus) {
            this.$message.success("订单支付成功");
            this.payModel.payStatus = false;
          }
        })
        .finally(() => {
          if (!this.payModel.payStatus) {
            setTimeout(() => {
              this.checkPay();
            }, 1000);
          }
        });
    },
    sureCancel() {
      cancelOrderApi({
        orderId: this.cancelModel.orderId,
      }).then((res) => {
        if (res.resultStatus) {
          this.$message.success("订单取消成功");
          this.cancelModel.flag = false;
        } else {
          this.$message.warning(res.errorMessage);
        }
      })
      .finally(()=>{
        this.getInfo(1)
      })
    },
    sureCertificate() {
      if (!this.certificateModel.authenticationId1) {
        this.$message.warning("选择已有品牌授权书或商标注册证书");
        return;
      }
      if (!this.certificateModel.authenticationId2) {
        this.$message.warning("选择已有委印许可证明");
        return;
      }
      authenticationApi({
        authenticationId1: this.certificateModel.authenticationId1,
        authenticationId2: this.certificateModel.authenticationId2,
      }).then((res) => {
        if (res.resultStatus) {
          this.$message.success("补传证书成功");
          this.certificateModel.flag = false;
          this.getInfo(1);
        }
      });
    },
    changeAddressArray() {
      if (this.addressModel.addressArray.length === 4) {
        this.addressModel.province = this.addressModel.addressArray[0];
        this.addressModel.city = this.addressModel.addressArray[1];
        this.addressModel.area = this.addressModel.addressArray[2];
        this.addressModel.street = this.addressModel.addressArray[3];
      }
    },
    // 估价
    toGetPrice() {
      if (!this.addressModel.routeTitle) {
        this.$message.warning("请输入路线");
        return;
      }
      if (!this.addressModel.expressName) {
        this.$message.warning("请输入快递公司");
        return;
      }
      if (!this.addressModel.addressArray === 4) {
        this.$message.warning("请选择省市区街道");
        return;
      }
      if (!this.addressModel.address) {
        this.$message.warning("请输入详细地址");
        return;
      }
      changeAddressPostageApi({
        orderId: this.addressModel.orderId,
        routeTitle: this.addressModel.routeTitle,
        expressName: this.addressModel.expressName,
        province: this.addressModel.province,
        city: this.addressModel.city,
        area: this.addressModel.area,
        street: this.addressModel.street,
        address: this.addressModel.address,
      }).then((res) => {
        if (res.resultStatus) {
          this.addressModel.freightPrice = res.resultData.freightPrice || 0;
        } else {
          this.$message.warning(res.errorMessage);
        }
      });
    },
    sureChangeAddress() {
      if (!this.addressModel.routeTitle) {
        this.$message.warning("请输入路线");
        return;
      }
      if (!this.addressModel.expressName) {
        this.$message.warning("请输入快递公司");
        return;
      }
      if (!this.addressModel.addressArray === 4) {
        this.$message.warning("请选择省市区街道");
        return;
      }
      if (!this.addressModel.address) {
        this.$message.warning("请输入详细地址");
        return;
      }
      if (!this.addressModel.freightPrice) {
        this.$message.warning("请点击估价查看并确认运费后再提交");
        return;
      }
      changeAddressApi({
        orderId: this.addressModel.orderId,
        routeTitle: this.addressModel.routeTitle,
        expressName: this.addressModel.expressName,
        province: this.addressModel.province,
        city: this.addressModel.city,
        area: this.addressModel.area,
        street: this.addressModel.street,
        address: this.addressModel.address,
        phone: this.addressModel.phone,
        contactName: this.addressModel.contactName,
      }).then((res) => {
        if (res.resultStatus) {
          this.$message.success("修改地址成功");
          this.addressModel.flag = false;
          this.getInfo(1);
        } else {
          this.$message.warning(res.errorMessage);
        }
      });
    },
    toUpload() {
      this.certificateModel.flag = false;
      this.$store.commit("UPDATE_ACTIVE_MENU", "6-5");
      this.$router.push({
        name: "authentication",
      });
    },
    getRouteTitleList() {
      routeListApi().then((res) => {
        if (res.resultStatus) {
          this.routeTitleList = (res.resultData.routeList || []).map((f) => {
            const obj = {
              label: f.routeTitle,
              value: f.routeTitle,
              ...f,
            };
            return obj;
          });
        }
      });
    },
    getauthenList() {
      authenticationListApi({
        pageNo: 1,
        pageSize: 999,
        authenticationType: "BRAND_TRADE_MARK",
        verifyStatus: "SUCCESS",
        expirType: false,
      }).then((res) => {
        if (res.resultStatus) {
          this.authenticationId1List = (
            res.resultData.authenticationList || []
          ).map((f) => {
            const obj = {
              label: f.authenticationTitle,
              value: f.authenticationId,
              ...f,
            };
            return obj;
          });
        }
      });
      authenticationListApi({
        pageNo: 1,
        pageSize: 999,
        authenticationType: "PROXY ",
        verifyStatus: "SUCCESS",
        expirType: false,
      }).then((res) => {
        if (res.resultStatus) {
          this.authenticationId2List = (
            res.resultData.authenticationList || []
          ).map((f) => {
            const obj = {
              label: f.authenticationTitle,
              value: f.authenticationId,
              ...f,
            };
            return obj;
          });
        }
      });
    },
  },
};
</script>

<style lang="less">
.orderManege_page {
  width: 100%;
  min-height: 100%;
  border: 1px solid #e1e1e1;
  padding: 20px;
  box-sizing: border-box;
  .title_box {
    margin-bottom: 12px;
  }
  .width200 {
    width: 200px;
  }
  .width150 {
    width: 150px;
  }
  .content_box {
    width: 100%;
    box-sizing: border-box;
    .table_content {
      width: 100%;
      box-sizing: border-box;
    }
    .statics {
      font-size: 14px;
      font-weight: bold;
      margin-top: 12px;
    }
    .price {
      color: #00a0e9;
    }
  }
}
.payImg {
  width: 100px;
  height: 100px;
}
.el-tabs__item {
  color: #999;
}
.el-tabs__item:hover {
  color: #00a0e9;
}
.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border: 1px solid #2f4050;
  border-bottom: 0;
}
.el-tabs__item.is-active {
  color: #000000;
}
</style>